export default __webpack_public_path__ + "static/media/waste-water.2c1f1bad.png";